import { render, staticRenderFns } from "./ServiceForm.vue?vue&type=template&id=24d46188&"
import script from "./ServiceForm.vue?vue&type=script&lang=js&"
export * from "./ServiceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports